import axios from 'axios';

import { LocalStorage } from '@data/enums';

import { TaskQueueStateTransitionResource } from './types';

// Self-contained call to the Request queue state log endpoint.
//
// We intentionally do NOT add this to the shared dy-frontend-http-repository
// package: that would require pushing a third repo and bumping the lockfile.
// Instead we reuse the exact same configuration the app already uses — the
// API base URL from the build-time env and the bearer access token from
// localStorage (the same key the shared repository instance is seeded with).
export const getTaskQueueStateTransitionLog = async (taskId: ID): Promise<TaskQueueStateTransitionResource[]> => {
    const baseURL = (process.env.API_BASE_URL ?? '').replace(/\/+$/, '');
    const accessToken = localStorage.getItem(LocalStorage.ACCESS_TOKEN);

    const { data } = await axios.get(`${baseURL}/api/task/${taskId}/queue`, {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });

    // Endpoint returns a QueryCollectionOutput: { items: [...], paginator, cursor, sort }
    return data?.items ?? [];
};
